import { ActionButton, ActionButtonType, DialogContent, Callout } from "@octopusdeploy/design-system-components";
import * as React from "react";
import Dialog from "../Dialog/Dialog";
export interface SupportTicketSuccessDialogProps {
    open: boolean;
    onClose: () => void;
    systemReportWarning?: string | null;
}
export function SupportTicketSuccessDialog({ open, onClose, systemReportWarning }: SupportTicketSuccessDialogProps) {
    const actions = <ActionButton type={ActionButtonType.Save} label="Close" onClick={onClose}/>;
    return (<Dialog open={open} title={`Thanks, we've received your request`} dialogWidth="480px" actions={actions}>
            <DialogContent>
                {systemReportWarning && (<Callout type="warning" title="System report was not included" hideTitle={false}>
                        <p>{systemReportWarning}</p>
                        <p>You can try generating a system report separately from Configuration → Diagnostics.</p>
                    </Callout>)}

                <p>You'll get a confirmation email shortly, and our team will be in touch soon.</p>

                <p>
                    In the meantime, you can visit our{" "}
                    <a href="https://octopus.com/support" target="_blank" rel="noopener noreferrer">
                        support page
                    </a>{" "}
                    or read our{" "}
                    <a href="https://octopus.com/docs" target="_blank" rel="noopener noreferrer">
                        docs
                    </a>
                    .
                </p>
            </DialogContent>
        </Dialog>);
}
